var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadReportInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27372 5.35937H8.27906M8.27372 10.6927V7.35937M14.9404 8.02604C14.9404 11.708 11.9557 14.6927 8.27372 14.6927C4.59172 14.6927 1.60706 11.708 1.60706 8.02604C1.60706 4.34404 4.59172 1.35938 8.27372 1.35938C11.9557 1.35938 14.9404 4.34404 14.9404 8.02604Z",
    stroke: "#6A6A6A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadReportInfo);
export default __webpack_public_path__ + "static/media/lead-report-info.d7f80e9a069e1bf1eba1f2098361075c.svg";
export { ForwardRef as ReactComponent };